import type { ReactNode } from 'react'
import { lunarsWord } from '@lunary/app-core/lunars-format'
import { LunarCoin } from './lunar-coin'
import styles from './lunar-text.module.css'

type AmountProps = { n: number; size?: number; word?: boolean; sign?: boolean }

export function LunarAmount({ n, size = 16, word = false, sign = false }: AmountProps) {
  const prefix = sign ? (n > 0 ? '+' : n < 0 ? '−' : '') : ''
  return (
    <span className={styles.amount}>
      <LunarCoin size={size} className={styles.coin} />
      <span>
        {prefix}
        {sign ? Math.abs(n) : n}
        {word ? ` ${lunarsWord(n)}` : ''}
      </span>
    </span>
  )
}

const AMOUNT = /(\d+) лунар(?:а|ов)?(?![а-яё])/gi

export function LunarText({ children, size = 16 }: { children: string; size?: number }): ReactNode {
  const parts: ReactNode[] = []
  let last = 0
  for (const m of children.matchAll(AMOUNT)) {
    const at = m.index ?? 0
    if (at > last) parts.push(children.slice(last, at))
    parts.push(<LunarAmount key={at} n={Number(m[1])} size={size} />)
    last = at + m[0].length
  }
  if (last < children.length) parts.push(children.slice(last))
  return parts
}
